import { useStore } from 'effector-react'
import { $strategy, getStrategy, strategyMounted } from './model'
import { useEffect } from 'react'

export const useStrategyDetails = () => {
  const strategy = useStore($strategy)
  const loading = useStore(getStrategy.pending)

  useEffect(() => {
    strategyMounted()
  }, [])

  return { strategy, loading }
}
